import { DASHBOARD_INSTANCE_LIST } from 'client/redux/dashboard/constants';
import { accountInstanceList } from 'client/redux/account/actionCreators';

export const dashboardInstanceList = () => dispatch => {
  return dispatch(accountInstanceList(DASHBOARD_INSTANCE_LIST));
};
